import { useAppSelector } from './store';

/**
 * Gets the shop ID as specified in the terminal config. Throws an error when
 * the terminal config is not loaded.
 */
export default function useShopId() {
  return useAppSelector(state => state.root.terminal.config?.shop);
}
